import {
  electricPurple000,
  electricPurple500,
  electricPurple600,
  monserratSemiBold,
  robotoRegular,
  scarpaGray50,
  scarpaGray500,
} from '@habitech/shared';
import styled from 'styled-components';

export const WrapperTable = styled.div`
  font-family: ${robotoRegular};
  width: 100%;
  .headers {
    font-size: 14px;
    font-weight: 900;
  }
  table {
    border: 1px solid rgba(243, 243, 243, 1);
  }
  thead {
    position: sticky;
    top: 0px;
    z-index: 5;
  }
  th {
    padding: 14px !important;
    background: rgba(250, 250, 250, 1);
  }
  .rows {
    font-size: 13px;
  }
  td {
    padding: 10px !important;
    border-bottom: 1px solid #e6e5e7;
    vertical-align: middle;
  }
  .table-scroll {
    overflow: scroll;
    height: calc(100vh - 180px);
  }
  .badge-comite {
    font-weight: 400 !important;
    font-size: 13px;
    background-color: rgba(230, 239, 253, 1) !important;
    color: #1e3a8a !important;
  }
  .badge-inmobiliaria {
    font-size: 13px;
    background-color: rgba(204, 229, 221, 1) !important;
    color: #206a5d !important;
    font-weight: 400 !important;
  }

  .wrapper-tasks {
    font-size: 14px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border: 1px solid rgba(243, 243, 243, 1);
    position: sticky;
    top: 0;
    height: 56px;
    z-index: 2;
  }
  .tasks {
    background: rgba(243, 243, 243, 1) !important;
    color: ${scarpaGray500};
  }
  .actions-cell {
    white-space: nowrap;
    width: 1%;
  }
  .btn:disabled {
    color: ${scarpaGray500} !important;
  }
  .comment-cell {
    max-width: 300px;
  }
`;

export const WrapperCheckInput = styled.div`
  .form-check-input {
    margin: 0;
    padding: 0;
    width: 15px;
    height: 15px;
    border: 1px solid #979499;
    &:checked {
      background-color: rgb(124, 1, 255);
      border-color: rgb(124, 1, 255);
    }
    &:active {
      background: white !important;
      color: #212529 !important;
    }
  }
`;

export const WrapperReassignButton = styled.div`
  display: flex;
  align-items: center;
  .btn {
    border: 1px solid var(--Brand-Turquoise-950, #071211);
    background: var(--Brand-Turquoise-950, #071211);
    color: var(--Brand-Turquoise-00, #ffffff);
    font-family: ${robotoRegular};
    font-weight: 400;
    font-size: 13px;
    border-radius: 8px;
  }
  .btn:active {
    border: 1px solid var(--Brand-Turquoise-950, #071211);
    background: var(--Brand-Turquoise-950, #071211);
    color: var(--Brand-Turquoise-00, #ffffff);
    border-radius: 8px;
  }
`;

export const WrapperModal = styled.div`
  background: ${scarpaGray50};
  border-radius: 8px;
  .subtitle {
    font-family: ${robotoRegular};
    font-size: 14px;
  }
  .description {
    font-family: ${robotoRegular};
    color: ${scarpaGray500};
    font-size: 14px;
    line-height: 18px;
  }
  .modal-title {
    font-size: 16px;
    font-weight: bold;
    font-family: ${monserratSemiBold};
  }
  .btn-habi-white {
    font-size: 14px;
    height: 35px;
    font-family: ${robotoRegular};
    background-color: ${electricPurple000};
    color: ${electricPurple600};
    border: 1px solid ${electricPurple000};
    border-radius: 8px;
  }
  .btn-habi-white:hover {
    color: ${electricPurple600};
    background-color: rgb(214, 243, 255);
    border: 1px solid rgb(214, 243, 255);
  }
  .btn-habi {
    height: 35px;
    font-size: 14px;
    font-family: ${robotoRegular};
    background-color: ${electricPurple500};
    border: none;
    border-radius: 8px;
  }
  .btn-habi:hover {
    background-color: ${electricPurple600};
  }
  .htTptB.white .placeholder {
    font-size: 14px;
    background: white;
  }
  .jkIYjY p {
    font-size: 14px;
  }
  .coCseG.white .placeholder {
    background-color: white;
    font-size: 15px;
  }
  .coCseG.white .emptyPlaceHolder {
    color: #949494;
    font-size: 15px;
  }
  .gPKrdT.white .placeholder {
    background-color: white;
    font-size: 15px;
  }
  .form-control {
    font-size: 14px;
    font-family: ${robotoRegular};
  }
  .badge-ctl {
    background-color: #7f8dd6 !important;
  }
  .badge-deed {
    background-color: #57abd0 !important;
  }
  .badge-admin {
    background-color: #e79633 !important;
  }
  .badge-hubspot {
    background-color: #61d298 !important;
  }
  .badge-beepquest {
    background-color: #d97bc4 !important;
  }
  .badge-appraisal {
    background-color: #5b9bd5 !important;
  }
  .badge-polynator {
    background-color: #70ad47 !important;
  }
  .badge-bigquery {
    background-color: #4285f4 !important;
  }
  .badge-sig {
    background-color: #b77a8f !important;
  }
  .badge-google-maps {
    background-color: #ea4335 !important;
  }
  .badge-report-remo {
    background-color: #ff6f61 !important;
  }
  .badge-georeference {
    background-color: #9c27b0 !important;
  }
  .badge-my-maps {
    background-color: #00bcd4 !important;
  }
  .badge-remo-measurement {
    background-color: #ff9800 !important;
  }
  .badge-pricing {
    background-color: #4caf50 !important;
  }
`;
